import {Injectable, Inject} from 'ng-metadata/core';
import {MappingTablesCache} from '../../mappingTablesCache/mappingTablesCache.service';
import {getVid, getInstitutionCode, getAutoSwitchQuicklinks} from '../../appConfig/appConfigForward';
import {getBackendSystem, getQuickLinkEnabled, isDisplayUnpaywallLinks} from '../../appConfig/appConfigForward';
import {HttpService} from '../../infra/httpRequest/http.service';
import { IPromise } from 'angular';
import {ConfigurationUtil} from "../../nddUtils/configurationUtil.service";


const get = require('lodash/get');
const set = require('lodash/set');
const _ = require('lodash');
const isEmpty = require('lodash/isEmpty');
const isEqual = require('lodash/isEqual');

@Injectable()
export class QuickLink {

    private _linksDefinitions: any;
    private vid = getVid();
    private jsonResponseString;
    private _unpaywallLinks;
    private isQuickLinksEnabled;
    private isUnpaywallEnabled;
    private excludeProxyValues = ["unpaywall"];
    private _showNoLinksErrorlabel: boolean = true;
    private _proxyValue: string;
    private HAN_PROXY: string = "HAN_proxy";
    private isAiInsightsLinkEnabled : boolean = false;

    constructor(@Inject('$http') private $http,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                @Inject('restBaseURLs') private restBaseURLs,
                @Inject('$q') private $q: ng.IQService,
                private mappingTablesCache: MappingTablesCache,
                private httpService : HttpService,
                private configurationUtil: ConfigurationUtil) {
        this.isQuickLinksEnabled = this.isQuickLinksEnabledFromConfig();
        this.isUnpaywallEnabled = this.isUnpaywallEnabledFromConfig();
        this.isAiInsightsLinkEnabled = this.isAiInsightsLinkEnabledFromConfig();
    }


    get quickLinksEnabled() {
        return this.isQuickLinksEnabled;
    }

    get unpaywallEnabled() {
        return this.isUnpaywallEnabled;
    }

    get unpaywallLinks() {
        return this._unpaywallLinks;
    }

    set showNoLinksErrorlabel(value: boolean) {
        this._showNoLinksErrorlabel = value;
    }

    get showNoLinksErrorlabel() {
        return this._showNoLinksErrorlabel;
    }

    public getQuickLinksFromPnx(item) {
        if (!this.isQuickLinksEnabled) {
            return;
        }

        let linksToReturn = [];                          // Initial array of quick links objects
        if (get(item, 'pnx.links.linktopdf[0]', false)) {
            let quickLinkObj = this.parseAndGetQuickLinkObj(item.pnx.links.linktopdf[0], 'PDF');
            linksToReturn.push(quickLinkObj);
        }
        if (get(item, 'pnx.links.linktohtml[0]', false)) {
            let quickLinkObj = this.parseAndGetQuickLinkObj(item.pnx.links.linktohtml[0], 'HTML');
            linksToReturn.push(quickLinkObj);
        }

        return linksToReturn;
    }

    public calculatetQuickLinks(item){
        let linksToReturn = this.getQuickLinksFromPnx(item);
        return this.updateQuickLinkObj(linksToReturn, item);
    }

    private addSearchKeyWordsToQuickLinkIfNeeded(url: string): string {
        const { mode, query = '' } = this.$stateParams || {};
        try {
            if (mode === 'advanced' || !url.includes('www.proquest.com'))
                return url;
            const searchKeyword = query ? query.split(',').slice(2).join(',').slice(0, 200) : '';
            if(searchKeyword)
                url += (url.indexOf('?') === -1 ? '?' : '') + '&searchKeywords=' + encodeURIComponent(searchKeyword);
            return url;
        } catch {
            return url;
        }
    }

    private parseUrlForQuickLink(fullQuickLink): string {
        const url = this.getSubfieldFromVal(fullQuickLink + '', '$$U');
        return this.addSearchKeyWordsToQuickLinkIfNeeded(url);

    }

    private parseAndGetQuickLinkObj(fullQuickLink, elementType){
        const isAiInsights = elementType === undefined;
        let quickSourceType = this.getSubfieldFromVal(fullQuickLink + '', '$$S');
        let quickOA = this.getSubfieldFromVal(fullQuickLink + '', '$$H');
        let url = this.parseUrlForQuickLink(fullQuickLink);
        let priority = this.getSubfieldFromVal(fullQuickLink + '', '$$P');
        let provider = this.getSubfieldFromVal(fullQuickLink + '', '$$G');

        let quickLinkType = this.getSubfieldFromVal(fullQuickLink + '', '$$E');
        if (elementType && (quickLinkType.toUpperCase() !== elementType.toUpperCase())) {
            return ({});
        }

        if (isAiInsights) {
            elementType = 'ai_insights';
            quickLinkType = 'AI_INSIGHTS';
        }
        let sourceTypeForLabels 	= "";
        let sourceTypeForLabelsAria = "";
        if(quickSourceType === "unpaywall"){
            sourceTypeForLabels = quickSourceType+".";
        }
        else {
            sourceTypeForLabelsAria = isAiInsights ? sourceTypeForLabelsAria : "quicklink.";
        }

        this.proxyValue = this.getProxyValue(quickSourceType, quickOA);

        let jsonObject =
            {
                "type": quickLinkType,
                "url": url,
                "priority": priority,
                "provider": provider,
                "oaLink": quickOA,
                "sourceType": quickSourceType,
                "tooltip": 'fulldisplay.' + sourceTypeForLabels + elementType + '.tooltip',
                "label": 'fulldisplay.' + sourceTypeForLabels + elementType,
                "ariaLabel": 'nui.aria.' + sourceTypeForLabelsAria + sourceTypeForLabels + elementType
            };

        return jsonObject;
    }

    get proxyValue() {
        return this._proxyValue;
    }

    set proxyValue(value) {
        this._proxyValue = value;
    }

    // Link should be proxied by using the proxy value from BO :
    // In case the configuration 'Do not proxy open access records' is not checked
    // In case the configuration 'Do not proxy open access records' is checked and no $$Hfree_for_read indication is included in the link
    // Otherwise (OA link and checked), use an empty proxy
    private async updateQuickLinkObj(linksToReturn, item){

        let linksObjArr = await this.preapareQuickLinksObjArr(linksToReturn);

        // Add proxy prefix (for both cases EZproxy or HAN) : if not unpaywall AND proxy is configured
        // Call Server with array of links objects
        // Get from server proxied array of links objects
        if(linksObjArr.length > 0){
            if(getBackendSystem() !== 'suprima' && this.proxyValue === this.HAN_PROXY){
                await this.getProxiedLinksIfDefined(item, linksObjArr).then((parsedLinks: any) => {
                    if(!isEmpty(parsedLinks) && parsedLinks != null){
                        linksToReturn = parsedLinks;
                    }
                });
            }
        }

        return linksToReturn;
    }

    private async getProxiedLinksIfDefined(item, linksObjArr){
        let payload = {'records':[{'record': item,'links': linksObjArr}] };
        let dataToBeSent = this.buildData();
        return this.asyncCall(payload, dataToBeSent);
    }

    private preapareQuickLinksObjArr(linksToReturn){
        let quickLinksObjArr = [];                             // Array quick links objects

        // Loop on each quick link and push to quickLinksObjArr if we have HAN_proxy value
        // else, Continue as before for EZproxy
        linksToReturn.forEach(quickLinkObj => {
            if(getBackendSystem() !== 'suprima' && this.proxyValue === this.HAN_PROXY){
                quickLinkObj.enableProxy = true;
                quickLinksObjArr.push(quickLinkObj);
            }else{                                          // Continue as before for EZproxy
                quickLinkObj.url = this.proxyValue + quickLinkObj.url;
            }
        });

        return quickLinksObjArr;
    }

    private asyncCall(payload, dataToBeSent) : IPromise<{}> {
        return this.$q((resolve)=>{
            this.httpService.callPostAndParams(this.restBaseURLs.proxyUrl, dataToBeSent, payload).then((parsedLinks: any) => {
                resolve(parsedLinks);
            });
        });
    }

    private getProxyValue(quickSourceType, quickOA){
        let institutionBaseURLs = this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.INSTITUTIONS_BASE_URLS, {source1: getInstitutionCode(),source2: 'proxy_prefix'});
        let proxyValue = '';

        // Add proxy prefix (for both cases EZproxy or HAN) : if not unpaywall AND proxy is configured
        if (!this.excludeProxyValues.includes(quickSourceType) && get(institutionBaseURLs,'[0].target')){
            proxyValue = (quickOA == 'free_for_read' && this.isDoNotProxyOpenAccessRecordsEnabled(institutionBaseURLs)) ? '' : get(institutionBaseURLs,'[0].target');
        }

        return proxyValue;
    }

    private buildData() {
        let dataToBeSent = {
            linkCode: 'quicklink',
            inst: this.$stateParams['inst'] || getInstitutionCode(),
            lang: this.$translate.use()
        };
        return dataToBeSent;
    }

    public isQuickLinksAvailable(item) {

        let quickLinkAvailableInPnx = get(item, 'pnx.links.linktopdf[0]', false) || get(item, 'pnx.links.linktohtml[0]', false);
        return (quickLinkAvailableInPnx && this.isQuickLinksEnabled);
    }

    public isQuickLinksEnabledFromConfig() {

        if (getBackendSystem() === 'suprima') {
            return this.isAutoSwitchEnabledInPrimoVE();
        }

        return this.isAutoSwitchEnabledInPrimoClassic();
    }

    public isAutoSwitchEnabledInPrimoVE(){
        // Auto switch Quick Links : check and return system configuration
        if(!getAutoSwitchQuicklinks()){ // if entry exists and the value is 'false' 
            // Regular Quick Links : check and return view level configuration
            return getQuickLinkEnabled();
        }
        return true; // The default value should be true (when no entry exists)
    }


    public isAutoSwitchEnabledInPrimoClassic(){
        // Auto switch Quick Links : check and return institution level configuration
        let props = window.appConfig['mapping-tables']['Institution Properties'];
        if(!props) return true;
        let prop = props.filter(entry => entry.source1 === 'auto_switch_quicklinks');
        if (prop && prop.length > 0) { // entry exists
            let propVal = prop[0].target.toLowerCase();
            if(propVal === 'false'){
                // Regular Quick Links : check and return view level configuration
                return this.mappingTablesCache.findByProperties('View Properties', { source1: getVid(), source2: 'enable_quicklink_icons', target: 'true'}).length !== 0;
            }else if(propVal === 'true'){
                return true;
            }
        }
        return true; // The default value should be true (when no entry exists)
    }

    public isUnpaywallEnabledFromConfig() {

        if (getBackendSystem() === 'suprima') {
            return isDisplayUnpaywallLinks();
        }
        return this.mappingTablesCache.findByProperties('View Properties', {
            source1: getVid(),
            source2: 'enable_unpaywall_links',
            target: 'true'
        }).length !== 0;
    }

    public isUnpaywallLinksAvailable(items) {

        if (!this.isUnpaywallEnabled) {
            return false;
        }

        //check if at least one linkunpaywall exists in PNX
        return items.some(item => 
            get(item, 'pnx.links.linkunpaywall[0]', false)
        );
    }

    public getSubfieldFromVal(value, subfield) {

        if (this.isSubfieldExist(value, subfield)) {
            let val = value.split(subfield)[1];
            if (val.indexOf('$$')!==-1) {
                val = val.substring(0, val.indexOf('$$'))
            }
            return val;
        } else {
            return value;
        }
    }

    public isSubfieldExist(value, subfield) {
        return value.includes(subfield);
    }


    public updateUnpaywallLinks(items) {

        if (!items || !this.isUnpaywallEnabled) {
            return;
        }

        let linksToReturn = [];
        for (let i = 0; i < items.length; i++) {
            let item = items[i];
            let linkunpaywall = get(item, 'pnx.links.linkunpaywall[0]', false);
            if (!linkunpaywall) {
                continue;
            }
            let linktopdf = get(item, 'pnx.links.linktopdf[0]', false);
            let linktohtml = get(item, 'pnx.links.linktohtml[0]', false);
            if (!this.isQuickLinksEnabled || (!linktopdf && !linktohtml)) {
                this.setUnpaywallLink(item, linkunpaywall, linksToReturn);
            }
        }

        this._unpaywallLinks = linksToReturn;
    }

    private setUnpaywallLink(item, linkunpaywall, linksToReturn: any[]) {
        let recordId = get(item, 'pnx.control.recordid[0]', '');

        if (recordId === "") {
            return;
        }
        let url = this.getSubfieldFromVal(linkunpaywall, '$$U');
        let provider = this.getSubfieldFromVal(linkunpaywall, '$$G') || '';
        let oaIndicator = this.getSubfieldFromVal(linkunpaywall, '$$H') || '';

        if (url) {
            let element = "$$U" + url + "$$EPDF$$P$$G" + provider + "$$H" + oaIndicator + "$$Sunpaywall";
            let array = [];
            array.push(this.parseAndGetQuickLinkObj(element, 'PDF'));
            linksToReturn[recordId] = array;
            set(item, 'pnx.links.linktopdf[0]', element);
        }
    }

    private fetchDOIsFromData(items) {
        // Prepare DOIs list in json format
        let jsonDois = {};

        for (let i = 0; i < items.length; i++) {
            let item = items[i];
            if (get(item, 'pnx.addata.doi')) {
                let linktopdf = get(item, 'pnx.links.linktopdf[0]', false);
                let linktohtml = get(item, 'pnx.links.linktohtml[0]', false);
                if (!this.isQuickLinksEnabled || (!linktopdf && !linktohtml)) {
                    let doi = get(item, 'pnx.addata.doi[0]', "");
                    let recordId = get(item, 'pnx.control.recordid[0]', "");
                    if (doi != "" && recordId != "") {
                        doi = doi.toLowerCase(); //Unpaywall (PQ) stores DOIs in lower case while CDI may send it in upper case
                        jsonDois[doi] = recordId;
                    }
                }
            }
        }
        return jsonDois;
    }


    public fetchURLsFromUnpaywall(jsonDoisString, items) {

        // Send GET request to Unpaywall restAPI (server)
        this.httpService.callPostAndParams(this.restBaseURLs.unpaywallURL, "", jsonDoisString)
            .then((data: any) => {

                let linksToReturn = [];
                for (var key in data) {
                    var url = data[key].url;
                    let array = [];
                    if (!(key.startsWith("beacon") || typeof url === 'undefined' || url === null)) {
                        var element = "$$U" + url + "$$EPDF$$P$$G$$H$$Sunpaywall";
                        array.push(this.parseAndGetQuickLinkObj(element, 'PDF'));
                        linksToReturn[key] = array;

                        for (var i = 0; i < items.length; i++) {
                            var item = items[i];
                            if (get(item, 'pnx.control.recordid[0]') == key) {
                                set(item, 'pnx.links.linktopdf[0]', "$$U" + url + "$$EPDF$$P$$G$$H$$Sunpaywall");
                            }
                        }
                    }
                }
                this._unpaywallLinks = linksToReturn;
            });
    }

    private isDoNotProxyOpenAccessRecordsEnabled(mtLine) {
        return mtLine && mtLine.length > 0 && mtLine[0].source4 !== undefined && isEqual(mtLine[0].source4, 'Y');
    }

    public getLinkProvider(item, linkType){
        if (get(item, 'pnx.links.'+linkType+'[0]', false)) {
            let provider = this.getSubfieldFromVal(get(item, 'pnx.links.'+linkType+'[0]', false), '$$G');
            if(provider){
                return provider;
            }
        }
    }

    public isPresentAiInsightsLink(item) : boolean {
        let isAiInsightsLinkAvailableInPnx = get(item, 'pnx.links.docinsights[0]', false);
        return (isAiInsightsLinkAvailableInPnx && this.isAiInsightsLinkEnabled);
    }

    public isAiInsightsLinkEnabledFromConfig() {
        let isAiInsightsLinkEnabledFromConfig = false;
        if (getBackendSystem() === 'suprima') {
            isAiInsightsLinkEnabledFromConfig = this.mappingTablesCache.findByProperties('View Properties', {
                source1: getVid(),
                source2: 'enable_ai_insights_links',
                target: 'true'
            }).length !== 0;
        }
        return isAiInsightsLinkEnabledFromConfig && this.configurationUtil.getFeatureFlag('doc_insigths_ff');
    }

    public calculateAiInsightsLink(item){
        let linksToReturn = this.getAiInsightsLinkFromPnx(item);
        return this.updateQuickLinkObj(linksToReturn, item);
    }

    public getAiInsightsLinkFromPnx(item) {
        let linksToReturn = [];
        const aiInsightsLink = this.parseAndGetQuickLinkObj(item.pnx.links.docinsights[0], undefined);
        linksToReturn.push(aiInsightsLink);
        return linksToReturn;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/quickLink/quickLink.service.ts